import React from "react";
import ObsIframe from "../../iframe-component/onboarding/ObsIframe";

const MerCalculator = () => {
  return <ObsIframe path="/mdr" />;
};

export default React.memo(MerCalculator);
